import { render } from "./VueKityminder.vue?vue&type=template&id=3346b4cd"
import script from "./VueKityminder.vue?vue&type=script&lang=js"
export * from "./VueKityminder.vue?vue&type=script&lang=js"

import "./VueKityminder.vue?vue&type=style&index=0&id=3346b4cd&lang=scss"

import exportComponent from "/home/jym/canvas_lms/lms/canvas/course_category_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__